import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

//selectors
import { useCampusVirtualIngresosEgresos } from "store/selectors"

const FormasPago = ({ dataColors }) => {
  //
  const apexSalesAnalyticsChartColors = getChartColorsArray(dataColors)
  const options = {
    labels: ["Series A", "Series B", "Series C"],
    colors: apexSalesAnalyticsChartColors,
    legend: { show: !1 },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    },
  }

  const [series, setSeries] = useState([0, 0, 0, 0, 0, 0])
  const [totales, setTotales] = useState([0, 0, 0, 0, 0, 0])

  const ingresosEgresos = useCampusVirtualIngresosEgresos()

  useEffect(() => {
    if (ingresosEgresos) {
      //
      if (!Array.isArray(ingresosEgresos)) {
        console.error("Error: La variable 'ingresosEgresos' no es un array.")
        return []
      }

      setTotales([0, 0, 0, 0, 0, 0])

      const datos = ingresosEgresos.reduce((acc, item) => {
        const formaPago = item.Forma_Pago

        // Si la forma de pago no existe en el acumulador, la inicializamos
        if (!acc[formaPago]) {
          acc[formaPago] = {
            Total_Ingresos: 0,
            Total_Gastos: 0,
          }
        }

        // Sumamos los ingresos y gastos
        acc[formaPago].Total_Ingresos += item.Total_Ingresos
        acc[formaPago].Total_Gastos += item.Total_Gastos

        return acc
      }, {})

      // Sumar todos los ingresos
      const totalIngresos = Object.values(datos).reduce(
        (sum, pago) => sum + (pago?.Total_Ingresos ?? 0),
        0
      )

      // Si no hay ingresos, evitar división por cero
      if (totalIngresos === 0) {
        setSeries([0, 0, 0, 0, 0, 0])
      } else {
        // Calcular porcentaje de cada forma de pago
        setSeries([
          ((datos["Cheque"]?.Total_Ingresos ?? 0) / totalIngresos) * 100,
          ((datos["Efectivo"]?.Total_Ingresos ?? 0) / totalIngresos) * 100,
          ((datos["Ficha de Deposito"]?.Total_Ingresos ?? 0) / totalIngresos) *
            100,
          ((datos["Tarjeta de Credito"]?.Total_Ingresos ?? 0) / totalIngresos) *
            100,
          ((datos["Transferencia"]?.Total_Ingresos ?? 0) / totalIngresos) * 100,
          ((datos["Tarjeta Débito"]?.Total_Ingresos ?? 0) / totalIngresos) *
            100,
        ])
        setTotales([
          datos["Cheque"]?.Total_Ingresos ?? 0,
          datos["Efectivo"]?.Total_Ingresos ?? 0,
          datos["Ficha de Deposito"]?.Total_Ingresos ?? 0,
          datos["Tarjeta de Credito"]?.Total_Ingresos ?? 0,
          datos["Transferencia"]?.Total_Ingresos ?? 0,
          datos["Tarjeta Débito"]?.Total_Ingresos ?? 0,
        ])
        setTotales(datos)
      }
    }
  }, [ingresosEgresos])

  return (
    <React.Fragment>
      <Col xl="8">
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">Formas de Pago</h4>
            <Row>
              <Col xl="9">
                <div>
                  <div id="donut-chart">
                    <ReactApexChart
                      options={options}
                      series={series}
                      type="donut"
                      height={260}
                      className="apex-charts"
                    />
                  </div>
                </div>
              </Col>
              <Col>
                <Row>
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-primary me-1" /> Cheque
                    </p>
                    <h5>{`$${(
                      totales["Cheque"]?.Total_Ingresos ?? 0
                    ).toLocaleString()}`}</h5>
                  </div>
                </Row>
                <Row>
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-success me-1" />{" "}
                      Efectivo
                    </p>
                    <h5>{`$${(
                      totales["Efectivo"]?.Total_Ingresos ?? 0
                    ).toLocaleString()}`}</h5>
                  </div>
                </Row>
                <Row>
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-danger me-1" /> Ficha
                    </p>
                    <h5>{`$${(
                      totales["Ficha de Deposito"]?.Total_Ingresos ?? 0
                    ).toLocaleString()}`}</h5>
                  </div>
                </Row>
              </Col>
            </Row>
            <div className="text-center text-muted">
              <Row>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-warning me-1" /> T.C.
                    </p>
                    <h5>{`$${(
                      totales["Tarjeta de Credito"]?.Total_Ingresos ?? 0
                    ).toLocaleString()}`}</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-info me-1" /> Transfer
                    </p>
                    <h5>{`$${(
                      totales["Transferencia"]?.Total_Ingresos ?? 0
                    ).toLocaleString()}`}</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-dark me-1" /> T.D
                    </p>
                    <h5>{`$${(
                      totales["Tarjeta Débito"]?.Total_Ingresos ?? 0
                    ).toLocaleString()}`}</h5>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default FormasPago
